import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import Button from '../button'
import { translate } from '../../helpers/stringHelpers'
import { formatCurrency } from '../../helpers/currencyHelpers'
import ConfigContext from '../../contexts/configContext'
import PURCHASE_TYPES from '../../constants/purchaseTypes'

const className = 'lot__action lot__action--purchase'

const PurchaseButton = ({ buyNowValue, currencyCode, isLot, nextBidValue, onPurchase, purchaseTypeId, ...props }) => {
  const { locale } = useContext(ConfigContext)
  const purchaseActionColor = isLot ? 'link' : 'primary'
  switch (purchaseTypeId) {
    case PURCHASE_TYPES.BUY_NOW:
      return buyNowValue && (!nextBidValue || !isLot || buyNowValue > nextBidValue)
        ? (
        <Button
          className={className}
          onClick={onPurchase}
          color={purchaseActionColor}
          {...props}
        >
          {translate('BiddingCodes_BUY_NOW')}{' '}
          <span className='lot__action--buy-now-price'>{formatCurrency(locale, currencyCode, buyNowValue)}</span>
        </Button>
          )
        : null

    case PURCHASE_TYPES.MAKE_OFFER:
      return (
        <Button
          className={className}
          onClick={onPurchase}
          color={purchaseActionColor}
          {...props}
        >
          {translate('BiddingCodes_MAKE_OFFER')}
        </Button>
      )

    case PURCHASE_TYPES.TENDER:
    case PURCHASE_TYPES.TENDER_PCT:
      return (
        <Button
          className={className}
          onClick={onPurchase}
          color={purchaseActionColor}
          {...props}
        >
          {translate('JspPublicCodes_JSP_BIDDING_TENDER')}
        </Button>
      )

    case PURCHASE_TYPES.NONE:
    default:
      return null
  }
}

PurchaseButton.propTypes = {
  buyNowValue: PropTypes.number,
  currencyCode: PropTypes.string.isRequired,
  nextBidValue: PropTypes.number,
  onPurchase: PropTypes.func.isRequired,
  isLot: PropTypes.bool.isRequired,
  purchaseTypeId: PropTypes.number.isRequired
}

export default React.memo(PurchaseButton)
